var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPaymentInstrumentAvailable
    ? _c(
        "div",
        {
          staticClass: "payments__instruments_item",
          class: { diss: !_vm.customerCanWithdraw || !_vm.hasMadeDeposit },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.go2InstrumentPage()
            }
          }
        },
        [
          _c("span", { staticClass: "piitem-picture" }, [
            _c("img", {
              attrs: {
                src: _vm.mediaServer(
                  "/static/brand-img/" + _vm.brandKey + "/card-v2.svg"
                ),
                alt: "card"
              }
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "piitem-text" }, [
            _c("div", { staticClass: "piitem-text-headline" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Payments.Nuvei.Card.Headline")) +
                  "\n      "
              ),
              !_vm.hasMadeDeposit && _vm.customerCanWithdraw
                ? _c("span", { staticClass: "piitem-must-deposit" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Payments.PNM.PayPalWithdrawal.Enable"))
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "piitem-text-desc" }, [
              _vm._v(_vm._s(_vm.$t("Payments.Nuvei.Card.Wd.Desc")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "piitem-arrow" },
            [_c("v-icon", [_vm._v("chevron_right")])],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc3d3a88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc3d3a88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Nuvei/NuveiWdCardLink.vue
// module id = null
// module chunks = 